import * as fe from 'fast-equals';
export function deepEqual(obj1, obj2) {
    return fe.deepEqual(obj1, obj2);
}
//# sourceMappingURL=equal.js.map